import React from 'react';
import './DynamicGrid.css';
import CarouselItem from '../CarouselItem';
import { CarouselItemProps } from '../../interfaces/CaroucelItemProps.interface';

interface DynamicGridProps {
  items: CarouselItemProps[];
}

const DynamicGrid: React.FC<DynamicGridProps> = ({ items }) => {
  return (
    <div className="dynamic-carousel-grid">
      {items.map((item) => (
        <CarouselItem
          key={item.id}
          imageSrc={item.urlImagen}
          title={item.nombre}
          time={item.tiempoPreparacion}
          description={item.descripcion}
          id={item.id}
          timeOfDay={item.section}
          alergico={item.alergico}
          favorito={item.favorito}
        />
      ))}
    </div>
  );
};

export default DynamicGrid;
